import { render } from "./ConfWebsite.vue?vue&type=template&id=46936967"
import script from "./ConfWebsite.vue?vue&type=script&lang=js"
export * from "./ConfWebsite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__